import React, { useEffect, useState } from "react";
import Wrapper from "../../helpers/Wrapper";
import BigSaleContainer from "./BigSaleContainer";
import { apiClient } from "../../helpers/Axios";
import { useQuery } from "@tanstack/react-query";

function BigSale() {

    const [hotSales, setHotSales] = useState([])

    const { data, isLoading } = useQuery({
        queryKey: ['hot-slaes'],
        queryFn: async () => {
            const res = await apiClient.get('/shop/hot-sales');
            return res.data;
        }
    })

    useEffect(() => {
        setHotSales(data || [])
    }, [data])


    return (
        <div className="w-full relative">
            <Wrapper>
                <div className="grid grid-cols-1 gap-5 min-[900px]:grid-cols-2 lg:gap-7">
                    {hotSales?.map((hot, i) => (
                        <BigSaleContainer key={i} loading={isLoading} data={hot} />
                    ))}
                </div>
            </Wrapper>
        </div>
    );
}

export default BigSale;
